// Console log filtering utility
// Bu dosya production ortamında console loglarını bastırır

const API_BASE_URL = import.meta.env.VITE_API_URL;
const originalLog = console.log;
const originalInfo = console.info;
const originalWarn = console.warn;

// Production ortamında bazı logları filtrele
if (import.meta.env.PROD || window.location.hostname !== 'localhost') {
  console.log = function(...args) {
    // Network fetch loglarını filtrele
    const message = args.join(' ');
    if (message.includes('Fetch finished loading') || 
        message.includes(`GET "${API_BASE_URL}/api/`)) {
      return;
    }
    originalLog.apply(console, args);
  };

  console.info = function(...args) {
    const message = args.join(' ');
    if (message.includes('Fetch finished loading') || 
        message.includes(`GET "${API_BASE_URL}/api/`)) {
      return;
    }
    originalInfo.apply(console, args);
  };
}

// Development ortamında da aşırı verbose logları azalt
else {
  let lastLogTime = {};
  const LOG_THROTTLE = 1000; // 1 saniyede bir aynı log

  console.log = function(...args) {
    const message = args.join(' ');
    
    // Frequent API calls için throttling
    if (message.includes('/api/messages') || 
        message.includes('/api/realtime') ||
        message.includes('Fetch finished loading')) {
      
      const now = Date.now();
      if (lastLogTime[message] && (now - lastLogTime[message]) < LOG_THROTTLE) {
        return; // Skip this log
      }
      lastLogTime[message] = now;
    }
    
    originalLog.apply(console, args);
  };
}

export { originalLog, originalInfo, originalWarn };